import { useMemo } from "react";
import { OptionsObject, useSnackbar } from "notistack";

import { CloseAction as action } from "./snackbarActions";

export default function useSnackbarMessage() {
  const snackbarContext = useSnackbar();

  if (snackbarContext === undefined) {
    throw new Error(
      "useSnackbarMessage must be used within a SnackbarProvider"
    );
  }
  const { enqueueSnackbar } = snackbarContext;

  return useMemo(
    () => ({
      info: (
        msg: string,
        options?: Omit<OptionsObject, "variant" | "action"> | undefined
      ) => {
        enqueueSnackbar(`${msg}`, {
          ...options,
          variant: "info",
          action,
        } as any);
      },
      success: (
        msg: string,
        options?: Omit<OptionsObject, "variant" | "action"> | undefined
      ) => {
        enqueueSnackbar(`${msg}`, {
          variant: "success",
          action,
        } as any);
      },
      warning: (
        msg: string,
        options?: Omit<OptionsObject, "variant" | "action"> | undefined
      ) => {
        enqueueSnackbar(`${msg}`, {
          ...options,
          variant: "warning",
          action,
        } as any);
      },
      error: (
        msg: string,
        options?: Omit<OptionsObject, "variant" | "action"> | undefined
      ) => {
        enqueueSnackbar(`${msg}`, {
          variant: "error",
          action,
        } as any);
      },
    }),
    [enqueueSnackbar]
  );
}
